var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectBoxChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 3,
    fill: "#0085E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6057 17.5C10.3389 17.5 10.0855 17.3884 9.89873 17.1931L6.12346 13.2447C5.7366 12.8401 5.7366 12.1704 6.12346 11.7658C6.51031 11.3612 7.15063 11.3612 7.53749 11.7658L10.6057 14.9747L17.4625 7.80345C17.8493 7.39885 18.4896 7.39885 18.8765 7.80345C19.2634 8.20806 19.2634 8.87775 18.8765 9.28235L11.3128 17.1931C11.126 17.3884 10.8725 17.5 10.6057 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectBoxChecked);
export default __webpack_public_path__ + "static/media/select-box-checked.686f886cb23c36bd9b5164f8e8256698.svg";
export { ForwardRef as ReactComponent };